module.exports = "/images/electrum-logo.png?eacb3a480175cbcaf55718a37da41a1b";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/electrum-logo.png
// module id = uWXj
// module chunks = 0